// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + (chunkId === "503" ? "__federation_expose_Webhooks" : chunkId) + ".js"
}